import React from 'react';
import classNames from 'classnames';

import styles from './ChatbotErrorWindow.module.scss';

function ChatbotErrorWindow({ extraClass, errorNotice }) {
  return (
    <div className={classNames(
      styles.errorContainer,
      { [styles.extraClass]: !!extraClass },
    )}
    >
      {errorNotice || 'Chatbot is currently down please try again later.'}
    </div>
  );
}

export default ChatbotErrorWindow;
